module.exports = __webpack_public_path__ + "files/093acc5fd5444d7cdf475652dc7d6f8d.png";